import type { AccountNumber } from '../../../../generated-types';

export enum DownpaymentActionType {
    FROM_ACCOUNT_SELECTED = 'FROM_ACCOUNT_SELECTED',
    TO_ACCOUNT_SELECTED = 'TO_ACCOUNT_SELECTED',
    AMOUNT = 'AMOUNT',
    NOTE = 'NOTE',
    RESET = 'RESET',
    SHOW_FROM_ACCOUNTS = 'SHOW_FROM_ACCOUNTS',
    HIDE_FROM_ACCOUNTS = 'HIDE_FROM_ACCOUNTS',
    SHOW_TO_ACCOUNTS = 'SHOW_FROMTOOUNTS',
    HIDE_TO_ACCOUNTS = 'HIDE_TO_ACCOUNTS',
    RESET_WITH_FROM_ACCOUNT = 'RESET_WITH_FROM_ACCOUNT',
}

export type DownpaymentAction =
    | { type: DownpaymentActionType.FROM_ACCOUNT_SELECTED; payload: AccountNumber }
    | { type: DownpaymentActionType.TO_ACCOUNT_SELECTED; payload?: AccountNumber }
    | { type: DownpaymentActionType.AMOUNT; payload?: number }
    | { type: DownpaymentActionType.NOTE; payload: string }
    | { type: DownpaymentActionType.RESET }
    | { type: DownpaymentActionType.SHOW_FROM_ACCOUNTS }
    | { type: DownpaymentActionType.HIDE_FROM_ACCOUNTS }
    | { type: DownpaymentActionType.SHOW_TO_ACCOUNTS }
    | { type: DownpaymentActionType.HIDE_TO_ACCOUNTS }
    | { type: DownpaymentActionType.RESET_WITH_FROM_ACCOUNT; payload: AccountNumber | undefined };
